import React, { useState } from "react";
import api, { apiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { fmtIDR } from "@/lib/format";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function ShipToCustomerDialog({ order, customerName, onClose, onSaved }) {
  const sendable = order.items.map((i, idx) => ({ idx, ...i, can: (i.bought_qty || 0) - (i.shipped_qty || 0) })).filter((i) => i.can > 0);
  const [qty, setQty] = useState(() => Object.fromEntries(sendable.map((i) => [i.idx, i.can])));
  const [fee, setFee] = useState("");
  const [courier, setCourier] = useState("");
  const [resi, setResi] = useState("");
  const [note, setNote] = useState("");

  const save = async () => {
    const items = sendable.map((i) => ({ idx: i.idx, qty: Number(qty[i.idx]) || 0 })).filter((i) => i.qty > 0);
    if (items.length === 0) return toast.error("Isi qty minimal 1 barang");
    try {
      await api.post(`/orders/${order.id}/shipments`, { items, shipping_fee: Number(fee) || 0, courier, resi, note });
      toast.success("Pengiriman ke customer dicatat"); onSaved();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Kirim ke Customer — {customerName}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-slate-500">Hanya barang yang sudah dibeli & belum dikirim. Boleh kirim sebagian; sisanya dikirim lain waktu.</p>
          {sendable.length === 0 && <div className="text-sm text-amber-700">Tidak ada barang yang siap dikirim untuk order ini.</div>}
          {sendable.map((i) => (
            <div key={i.idx} className="flex items-center gap-2 text-sm border rounded px-2 py-1.5" data-testid={`ship-row-${i.idx}`}>
              <span className="flex-1 truncate">{i.name} <span className="text-xs text-slate-400">siap {i.can} pcs</span></span>
              <Input data-testid={`ship-qty-${i.idx}`} type="number" min="0" max={i.can} value={qty[i.idx]} onChange={(e) => setQty({ ...qty, [i.idx]: e.target.value })} className="w-20 h-8 font-mono" />
            </div>
          ))}
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Ongkir ke Customer (IDR, ditagih)</Label><Input data-testid="ship-fee" type="number" min="0" step="1000" value={fee} onChange={(e) => setFee(e.target.value)} /></div>
            <div><Label>Kurir</Label><Input data-testid="ship-courier" value={courier} onChange={(e) => setCourier(e.target.value)} placeholder="JNE / Gojek / Paxel" /></div>
            <div><Label>No. Resi</Label><Input data-testid="ship-resi" value={resi} onChange={(e) => setResi(e.target.value)} /></div>
            <div><Label>Catatan</Label><Input data-testid="ship-note" value={note} onChange={(e) => setNote(e.target.value)} /></div>
          </div>
          {Number(fee) > 0 && <div className="text-xs text-slate-500">Ongkir {fmtIDR(Number(fee))} ditagihkan ke customer (pass-through, tidak masuk profit).</div>}
        </div>
        <DialogFooter><Button data-testid="ship-save" onClick={save} disabled={sendable.length === 0} className="bg-slate-900 hover:bg-slate-800">Simpan Pengiriman</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
